import React, {
  createContext,
  useContext,
  useRef,
  useState,
  useMemo,
} from 'react';

import PropTypes from 'prop-types';

const StickyHeaderContext = createContext({
  autoHide: false,
  headerContentHeight: 0,
  stickyPortalRef: { current: null },
  setAutoHide: () => {},
  setHeaderContentHeight: () => {},
});

export function StickyHeaderProvider({ children }) {
  const [autoHide, setAutoHide] = useState(false);
  const [headerContentHeight, setHeaderContentHeight] = useState(0);
  const stickyPortalRef = useRef(null);

  const value = useMemo(
    () => ({
      autoHide,
      setAutoHide,
      headerContentHeight,
      setHeaderContentHeight,
      stickyPortalRef,
    }),
    [autoHide, headerContentHeight]
  );
  return (
    <StickyHeaderContext.Provider value={value}>
      {children}
    </StickyHeaderContext.Provider>
  );
}

StickyHeaderProvider.propTypes = {
  children: PropTypes.node,
};

export function useStickyHeader() {
  return useContext(StickyHeaderContext);
}
